import axios, { AxiosRequestConfig } from 'axios';
import { Toast } from 'vant';
import { sm4, md5 } from '@tenwit/tenone-crypto';
import { useGlobalStore } from '../../store';
import { setCookie, getCookie } from '@shared/utils';

if (import.meta.env.VITE_USER_NODE_ENV === 'development') {
  setCookie('caizhi_h5_key', '8892b92196af4ba68112b75e5c2a97e1%3B1097ed8ac4d94bcc8bf2a19eb2809fe4');
}

let isShowError = true;

const FailCode: any = {
  1000001: (url = '', resData: any) => {
    Toast('未登录或登录态失效');
    return Promise.reject(`${url},${JSON.stringify(resData)}`);
  },
  '-1': (url = '', resData: any) => {
    Toast(resData.retmsg);
    return Promise.reject(`${url},${JSON.stringify(resData)}`);
  },
  default: (url = '', resData: any) => {
    Toast(resData.retmsg);
    return Promise.reject(`${url},${JSON.stringify(resData)}`);
  },
};

const instance = axios.create({
  timeout: 60000,
});

instance.interceptors.request.use(
  function (config: AxiosRequestConfig<any>) {
    const globalStore = useGlobalStore();
    // console.log(config.url, config.headers);
    isShowError = !config.headers?.isHideError;
    // console.log(config.url, isShowError);
    if (config.headers?.['Content-Type'] === 'multipart/form-data') {
      const { data } = config;
      const fd = new FormData();
      for (const key in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(key)) {
          if (key.endsWith('[]')) {
            data[key].forEach((item: any) => {
              fd.append(key, item);
            });
          } else {
            fd.append(key, data[key]);
          }
        }
      }
      config.data = fd;
    }
    return {
      ...config,
      headers: {
        ...config.headers,
        'X-TenWit-CorpId': globalStore.appData?.currentCorpId,
      },
    };
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    const { headers, status, statusText, data, config } = response;
    if (status === 200) {
      // encrypt<string>，标识加密方式，1：国密sm4
      // 加密企业 交银等
      if (headers.encrypt === '1') {
        // SM4解密
        try {
          // 密钥，要求：将 caizhi_h5_key 用 md5 加密后的32位字符串，全16进制
          const key = md5(getCookie('caizhi_h5_key') || '');

          // 解密后的数据
          const dataStr = sm4.decrypt(data.retdata, key);
          data.retdata = JSON.parse(dataStr);
          console.log('解密后的数据', data);
        } catch (err) {
          console.log('解密失败', err);
        }
      }

      const { ret } = data;
      if (ret !== 0 && !config.headers?.isHideError) {
        return FailCode[ret] ? FailCode[ret](config.url, data) : FailCode.default(config.url, data);
      }
      return data;
    } else {
      isShowError && Toast(`接口出错：${config.url} [${status}]${statusText}`);
      return Promise.reject(response);
    }
  },
  function (error) {
    console.log({ error });
    isShowError && Toast(`接口出错：${error?.message} ${error?.message}`);
    return Promise.reject(error);
  }
);

export const httpClient = instance;
